import { useSelector } from "react-redux";
import { useFlags } from "launchdarkly-react-client-sdk";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../../../constants/PublicVariables";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import uploadFilesService from "../../../../services/uploadFilesService";
import googleEvent from "../../../../services/googleEvent";
import { EVENT_NAME } from "../../../../constants/GTagConstants";
import { ENABLED } from "../../../../constants/Constants";
import { isRemainingFileCountLess } from "../../../../shared/utility";
import clsx from "clsx";

const UploadFileButton = () => {
    const ldFlags = useFlags();

    const { isRemoteParticipantJoined } = useSelector((state) => state.commonReducer);

    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change*/
    const localisedValues = useLanguageChange();

    const isUploadFileButtonVisible = () => {
        if (GLOBAL_MEETING_DATA?.isAgent && ldFlags?.hideStartVideoButton) {
            return false;
        }

        return PublicVariables?.featureFlag?.UPLOADFILE === ENABLED && !CALL_DATA.isObserver;
    };

    const isUploadFileButtonDisabled = () => {
        return !isRemoteParticipantJoined || uploadFilesService.isUploadFilesView() || isRemainingFileCountLess();
    };

    const uploadButtonClickHandler = () => {
        googleEvent.logEvent(EVENT_NAME.UPLOAD_FILE_TAPPED);

        uploadFilesService.showUploadFilesView(null, localisedValues?.uploaded_max_file);
    };

    return (
        <>
            {isUploadFileButtonVisible() && (
                <div className='button-out' data-testid='fileUpload-button'>
                    <div className='button custom-tooltip center-tooltip m-hide'>
                        <button
                            className={clsx("btn short-btn", isUploadFileButtonDisabled() && "short-btn-disable")}
                            disabled={PublicVariables.isMobile ? "" : isUploadFileButtonDisabled()}
                            onClick={() => uploadButtonClickHandler()}
                        >
                            <span className='for-icon icon-upload'></span>
                            <span className='for-text'>{localisedValues?.upload}</span>
                        </button>
                        {isRemainingFileCountLess() && (
                            <div className='custom-tooltip-content text-center'>
                                <div className='custom-tooltip-in'>
                                    <p>{localisedValues?.uploaded_max_file}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default UploadFileButton;
